"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _glamor = require("glamor");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var browser = _interopRequireWildcard(require("./browser"));

var _Context = _interopRequireDefault(require("./Context"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ROOT_CSS = (0, _glamor.css)({
  boxSizing: 'border-box'
});

var _default = function _default(_ref) {
  var className = _ref.className,
      handlerClassName = _ref.handlerClassName;
  return _react.default.createElement(_Context.default.Consumer, null, function (_ref2) {
    var dir = _ref2.dir,
        scrollBarPercentage = _ref2.scrollBarPercentage,
        scrollBarWidth = _ref2.scrollBarWidth;
    return _react.default.createElement("div", {
      className: (0, _classnames.default)(ROOT_CSS + '', className)
    }, _react.default.createElement("div", {
      className: handlerClassName,
      style: _objectSpread({}, dir === 'rtl' ? browser.firefox || browser.safari ? {
        marginRight: "".concat((parseFloat(scrollBarWidth) / 100 - 1) * parseFloat(scrollBarPercentage), "%")
      } : browser.edgeUWP || browser.internetExplorer ? {
        marginRight: "".concat((1 - parseFloat(scrollBarWidth) / 100) * parseFloat(scrollBarPercentage), "%")
      } : {
        marginRight: "".concat((1 - parseFloat(scrollBarWidth) / 100) * (100 - parseFloat(scrollBarPercentage)), "%")
      } : {
        marginLeft: "".concat((1 - parseFloat(scrollBarWidth) / 100) * parseFloat(scrollBarPercentage), "%")
      }, {
        width: scrollBarWidth
      })
    }));
  });
};

exports.default = _default;